<template>
  <div class="sale-content">
    <div class="left">
      <div class="title">销售额统计</div>
      <div class="left-total">销售总额（万）：<span>{{priceInfo.allPrice}}</span></div>
      <div class="left-chart" id="lineChart"></div>
    </div>
    <div class="right">
      <div class="title">销售渠道分布</div>
      <div class="pie-chart" id="pieChartId"></div>
    </div>
  </div>
</template>

<script>
	import {
			queryEnterpriseInventorySaleStatistics,
			queryEnterpriseInventorySaleDetailStatistics
			
		} from "@/api/wms/warehouse.js";
export default {
	props: {
	  superviseId: {
	    typeof: String,
	    default: ''	
	  },
		loanYearQuery: {
		  typeof: String,
		  default: ''	
		}
	},
  components: {},
  data() {
    return {
		priceInfo:{
			allPrice:'-',
			detailList:[]
		}
	}
  },
	watch:{
		  loanYearQuery(newVal, oldVal){
			  this.getEnterpriseInventorySaleStatistics()
			  this.getEnterpriseInventorySaleDetailStatistics()
		  },
		  superviseId(newVal, oldVal){
				this.getEnterpriseInventorySaleStatistics()
				this.getEnterpriseInventorySaleDetailStatistics()
		  }
	},
  created() {},
  mounted() {
	  this.getEnterpriseInventorySaleStatistics()
	  this.getEnterpriseInventorySaleDetailStatistics()

  },

  methods: {
	  getEnterpriseInventorySaleStatistics(){
		queryEnterpriseInventorySaleStatistics({"superviseId":this.superviseId,"loanYearQuery":this.loanYearQuery}).then(res=>{
			console.log(res)
			if(res.status==200&&res.data.code==200&&res.data.result){
				this.priceInfo=res.data.result
				let priceList=[]
				this.priceInfo.detailList.forEach(item=>{
					priceList.push(item.price)
					
				})
				this.lineChart({
				  dom: 'lineChart',
				  xAxis: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
				  data: priceList,
				})
			}
		})  
	  },
	  getEnterpriseInventorySaleDetailStatistics(){
	  		queryEnterpriseInventorySaleDetailStatistics({"superviseId":this.superviseId,"loanYearQuery":this.loanYearQuery}).then(res=>{
	  			console.log(res)
	  			if(res.status==200&&res.data.code==200&&res.data.result){
	  				this.pieChart({
	  				  dom: 'pieChartId',
	  				  color: ['#D0BAA4', '#B98D4E', '#CBD9B9', '#9DA4BD','#92d041'],
	  				  data: [
	  				    
	  				    { value: res.data.result.orderMarketPercentage, name: '订单' },
	  				    { value: res.data.result.commerceMarketPercentage, name: '电商' },
	  				    { value: res.data.result.caterinMarketPercentage, name: '餐饮终端店' },
						{ value: res.data.result.otherMarketPercentage, name: '其他' },
						{ value: res.data.result.useMarketPercentage, name: '自有终端店' },
	  				  ],
	  				})
	  			}
	  		})  
	  },
    lineChart(data) {
      this.chart = this.$echarts.init(document.getElementById(data.dom))
      this.chart.setOption({
        color: ['rgba(146, 208, 65, 1)'],
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.8)',
          borderColor: '#292929',
          borderWidth: 1,
          textStyle: {
            color: '#EFAB44',
          },
          formatter: function (params) {
            let dom = ''
            console.log(data)
            params.forEach((item) => {
              dom += `<p>${item.seriesName}： ${item.value}万元</p>`
            })
            return `<div>${dom}</div>`
          },
        },
        grid: {
          left: '0%',
          right: '5%',
          bottom: '0%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            axisLabel: {
              color: 'rgba(255, 255, 255, 1)',
            },
            axisLine: {
              show: true, // X轴 网格线 颜色类型的修改
              symbol: ['none', 'arrow'],
              symbolSize: [6, 6],
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.15)',
              },
              interval: 0,
            },
            axisTick: {
              // X轴线 刻度线
              show: false,
            },
            data: data.xAxis,
          },
        ],
        yAxis: [
          {
            name: '万元',
            nameTextStyle: {
              color: 'rgba(255, 255, 255, 1)',
              padding: [1, 1],
            },
            type: 'value',
            axisLine: {
              symbol: ['none', 'arrow'],
              symbolSize: [6, 6],
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.15)',
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255,255,255,0.05)',
              },
            },
            axisLabel: {
              color: 'rgba(255, 255, 255, 1)',
            },
          },
        ],
        series: [
          {
            name: '销售总额',
            type: 'line',
            lineStyle: {
              width: 1,
            },
            smooth: true,
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 1,
                  color: 'rgba(146, 208, 65, 0)',
                },
                {
                  offset: 0,
                  color: 'rgba(146, 208, 65, 0.31)',
                },
              ]),
            },
            data: data.data,
          },
        ],
      })
    },
    pieChart(data) {
      this.chart = this.$echarts.init(document.getElementById(data.dom))
      this.chart.setOption({
        color: data.color,
        tooltip: {
          show: false,
          trigger: 'item',
          backgroundColor: 'rgba(255,255,255,0.8)',
          borderColor: '#292929',
          borderWidth: 1,
          textStyle: {
            color: '#EFAB44',
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['55%', '55%'],
            avoidLabelOverlap: false,
            selectedMode: true,
            labelLine: {
              show: false,
            },
            label: {
              position: 'inner',
              fontSize: 14,
              normal: {
                show: true, //开启提示线文字
                position: 'outer', //设置文字的所在的位置
                formatter: '{b} {c}%  \n\n', //设置展示的内容
                borderWidth: 20, //大小设置
                borderRadius: 4,
                color: '#FFFFFF', //文字颜色
                padding: [0, -30],
              },
              //   formatter: '{b}\n   {d}% ',
              // formatter: function (params) {
              //   if (params.percent === undefined) {
              //     return params.name + 0 + '%'
              //   } else if (params.percent === 0) {
              //     return params.name + params.percent + '%'
              //   } else {
              //     return params.name + params.percent + '%'
              //   }
              // },
            },
            labelLine: {
              normal: {
                show: true, //开启提示线展示
                length: 30, //设置第一条提示线长度
                length2: 30, //设置第二条提示线长度
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.3)',
                },
              },
            },
            data: data.data,
			minAngle:1,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      })
    },
  },
}
</script>

<style scoped lang="scss">
.sale-content {
  width: 100%;
  height: 4.5rem;
  display: flex;
  justify-content: space-between;
  .left {
    width: 5.5rem;
    height: 100%;
    // background-color: olive;
    &-total {
      font-size: 0.15rem;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      color: #ffffff;
      height: 0.25rem;
      //   background-color: antiquewhite;
      display: flex;
      align-items: flex-end;
      span {
        font-size: 0.25rem;
        font-family: DIN, DIN;
        font-weight: 700;
        color: #efab44;
      }
    }
    &-chart {
      width: 100%;
      height: 3rem;
      //   background-color: brown;
      margin-top: 0.25rem;
    }
  }
  .right {
    width: 5rem;
    height: 100%;
    // background-color: orange;
    .pie-chart {
      width: 100%;
      height: 3rem;
      //   background-color: brown;
      margin-top: 0.5rem;
    }
  }
  .title {
    width: 100%;
    height: 0.8rem;
    font-size: 0.175rem;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 700;
    color: #ffffff;
    display: flex;
    align-items: center;
    // background: blue;
  }
}
</style>
